import { isConsent } from '../../Services/httpCalls';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import useUser from '../../hooks/useUser';

export function useIsConsent(consent) {
  const navigate = useNavigate();
  const { isNewUser } = useUser();

  const handleNavigation = (isNewUser, isConesent, consentData) => {
    if (!isConesent || !consentData.is_user_certified) {
      navigate('/registration-form');
      return;
    }

    if (isNewUser) {
      navigate('/request');
    } else {
      navigate('/registry-review');
    }
  };

  return useMutation({
    mutationKey: [`isConsent`],
    mutationFn: async () => {
      return await isConsent(consent);
    },
    onSuccess: async (response) => {
      try {
        handleNavigation(isNewUser, consent, response.data);

        enqueueSnackbar(response.data.message, {
          variant: 'info',
          autoHideDuration: 2000,
        });
      } catch (error) {
        enqueueSnackbar('Παρουσιάστηκε σφάλμα.', {
          variant: 'error',
          autoHideDuration: 2000,
        });
      }
    },
    onError: (error) => {
      enqueueSnackbar('Παρουσιάστηκε σφάλμα.', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    },
  });
}
